import { useEffect } from 'react';
import { isIOS, isMacOs } from 'react-device-detect';
import { appZoom, theme } from '../theme';

const onAppResize = () => {
	const doc = document.documentElement;

	let zoom = 1;

	if (window.innerWidth >= theme.breakpoints.values.sm && (isMacOs || isIOS)) {
		zoom = appZoom;
	}

	doc.style.setProperty('--app-zoom', `${zoom}`);
};

export const useAppHeight = () => {
	useEffect(() => {
		window.addEventListener('resize', onAppResize);
		onAppResize();

		return () => {
			window.removeEventListener('resize', onAppResize);
		};
	}, []);
};
